import { render, staticRenderFns } from "./SpendChange.vue?vue&type=template&id=1e96ecde&scoped=true&"
import script from "./SpendChange.vue?vue&type=script&lang=js&"
export * from "./SpendChange.vue?vue&type=script&lang=js&"
import style0 from "./SpendChange.vue?vue&type=style&index=0&id=1e96ecde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96ecde",
  null
  
)

export default component.exports